<template>
      <div class="page">
           <el-form 
                 v-if="isSearch"
                :model="queryForm"
                ref="form"
                label-width="80px"
                :inline="true"
                size="small"
                class="query-form"
                @submit.native.prevent
           >
               <el-form-item label="商户名称"> 
                  <el-input  type="text" v-model="queryForm.shopName" placeholder="请输入商户名称"  ></el-input>
               </el-form-item>
               <el-form-item label="银行卡号">
                   <el-input type="text"   v-model="queryForm.bankCard" placeholder="请输入银行卡号"  ></el-input>
               </el-form-item>
           </el-form>
      <div class="page-content">
      <div class="page-tool-bar">
        <div class="operation">
        </div>
        <div class="icon-group">
            <span title="搜索" class="icon-box" @click="search">
                <Icon color="#606266">
                    <Search />
                </Icon>
            </span>
            <span class="icon-box" @click="getData">
                <Icon color="#606266">
                    <Refresh />
                </Icon>
            </span>
        </div>
      </div>
    </div>
    <!-- 数据 -->
      <el-table
        height='100%'
        :data="shopBrandList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
        border
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="legalPersonName"
          label="法人姓名"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="bankCard"
          label="银行卡号"
        >
        </el-table-column>
        <el-table-column  label="图片" align="center" prop="bankCardPic">
             <template slot-scope="scope">
                <el-image @click="updateSrcList(scope.row.bankCardPic)" style="width: 100px; height: 100px" :src="scope.row.bankCardPic"  :preview-src-list="srcList">
                 <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                 </div>
            </el-image>
             </template>
        </el-table-column>
      
       <el-table-column align="center" label="操作" width="400" fixed="right">
            <template slot-scope="scop">
                <el-button type="primary" size="mini" >编辑</el-button>
            </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
   </div>
</template>
<script >
import { Refresh,  Search } from '@v2icons/tabler';
import { get, post, deleteFun, upload ,postJson } from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';
  export default {
     components: {
        Refresh,
        Search,
  },
       data() {
          return {
               pageSize: 10,
               currentPage: 1,
               totalNum: 0,
               isSearch:false,
               loading:true,
               queryForm:{
                   shopName:'',
                   bankCard:'',
               },   
               shopBrandList:[{legalPersonName:'在拔火罐',bankCard:'12345678901',bankCardPic:""},{bankCard:'12345678901',bankCardPic:"https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg"}],
               srcList: [""]
          }
       },
       mounted() {
           
       },
       methods: {
        updateSrcList(row){ 
             this.srcList[0] =row;
        },
         search(){
            this.isSearch = !this.isSearch;
            },
            // 获取数据
         getData(){
                this.resetData()
                this.getDataList()
            },
         resetData(){
              this.pageSize = 10;
              this.currentPage = 1;
              this.shopBrandList = [];
            },
         handleSelectionChange(){

            },
         sizeChange(size) {
                this.pageSize = size;
                this.getData();
             },
          currentChange(page) {
                 this.currentPage = page;
                 this.getData();
               },
       },
   } 
</script>
<style scoped lang="scss">
  ::v-deep .el-table{
      margin-top: 0;
   } 
  .page-content{
        flex: 0;
    }
  .operation {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }
    .primary{
        background-color: #409eff;
        color: #fff;
        border-radius: 4px;
        height: 28px;
        line-height: 28px;
        margin-top: 15px;
    }
    .danger{
        background-color: #f56c6c;
        color: #fff;
        border-radius: 4px;
        height: 28px;
        line-height: 28px;
    }
}

</style>